import { render } from "./Index.vue?vue&type=template&id=2994d18a&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=2994d18a&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=2994d18a&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2994d18a"]])

export default __exports__